import { useSelector } from "react-redux";
import { HotelsAvailabilitySelectors } from "@b2bportal/core-hotels";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./HotelAvailabilityTitle.module.scss";

const COMPONENT_KEY = CoreHotelsComponent.HotelAvailabilityTitle;
export const HotelAvailabilityTitle = () => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const destination = useSelector(HotelsAvailabilitySelectors.getDestination);

  return (
    <div className={block} role="status" aria-live="polite">
      <h1 className={cn("title")}>
        {t("core-hotels.availabilityPage.title", {
          destination: destination?.label?.split(",")[0] ?? "",
          interpolation: { escapeValue: false },
        })}
      </h1>
    </div>
  );
};
